import React, { useEffect, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Syne:wght@700;800&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
.sf-root{min-height:100vh;background:#080b14;color:#e2e8f0;font-family:'DM Sans',sans-serif;}
.sf-header{position:sticky;top:0;z-index:20;background:rgba(8,11,20,.97);border-bottom:1px solid rgba(255,255,255,.07);padding:12px 16px;display:flex;align-items:center;gap:12px;}
.sf-logo{font-family:'Syne',sans-serif;font-size:18px;font-weight:800;color:#fff;text-decoration:none;}
.sf-logo span{color:#f5a623;}
.sf-tabs{display:flex;gap:2px;flex:1;}
.sf-tab{padding:7px 14px;border:none;background:transparent;color:#64748b;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:600;cursor:pointer;border-radius:8px;transition:all .18s;}
.sf-tab.active{background:rgba(99,102,241,.12);color:#818cf8;}
.sf-body{max-width:600px;margin:0 auto;padding:16px 16px 100px;}
/* Composer */
.sf-compose{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:16px;padding:14px;margin-bottom:16px;}
.sf-compose-row{display:flex;gap:10px;align-items:flex-start;}
.sf-compose-avatar{width:36px;height:36px;border-radius:50%;background:rgba(99,102,241,.2);display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#818cf8;flex-shrink:0;}
.sf-compose-avatar img{width:100%;height:100%;object-fit:cover;border-radius:50%;}
.sf-compose-input{flex:1;background:transparent;border:none;color:#e2e8f0;font-family:'DM Sans',sans-serif;font-size:14px;outline:none;resize:none;line-height:1.5;min-height:60px;}
.sf-compose-input::placeholder{color:#334155;}
.sf-compose-footer{display:flex;justify-content:flex-end;margin-top:10px;padding-top:10px;border-top:1px solid rgba(255,255,255,.06);}
.sf-post-btn{padding:'8px 18px';border-radius:99px;border:none;background:linear-gradient(135deg,#6366f1,#8b5cf6);color:#fff;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:700;cursor:pointer;padding:8px 18px;}
.sf-post-btn:disabled{opacity:.5;cursor:not-allowed;}
/* Post card */
.sf-card{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:16px;padding:14px;margin-bottom:12px;}
.sf-card-head{display:flex;align-items:center;gap:10px;margin-bottom:10px;}
.sf-avatar{width:38px;height:38px;border-radius:50%;background:rgba(99,102,241,.2);display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#818cf8;flex-shrink:0;text-decoration:none;}
.sf-avatar img{width:100%;height:100%;object-fit:cover;border-radius:50%;}
.sf-user-name{font-size:13px;font-weight:700;color:#e2e8f0;text-decoration:none;}
.sf-user-name:hover{color:#818cf8;}
.sf-time{font-size:11px;color:#475569;}
.sf-post-type{font-size:10px;padding:2px 8px;border-radius:99px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;}
.sf-type-checkin{background:rgba(52,211,153,.1);color:#34d399;border:1px solid rgba(52,211,153,.2);}
.sf-type-achievement{background:rgba(245,166,35,.1);color:#fbbf24;border:1px solid rgba(245,166,35,.2);}
.sf-type-post{background:rgba(99,102,241,.1);color:#818cf8;border:1px solid rgba(99,102,241,.2);}
.sf-place-tag{display:inline-flex;align-items:center;gap:4px;font-size:12px;color:#6366f1;background:rgba(99,102,241,.08);padding:4px 10px;border-radius:99px;margin:6px 0 10px;text-decoration:none;}
.sf-card-text{font-size:14px;color:#e2e8f0;line-height:1.65;margin-bottom:10px;white-space:pre-wrap;}
.sf-card-photos{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:6px;margin-bottom:10px;}
.sf-card-photo{width:100%;aspect-ratio:1;object-fit:cover;border-radius:10px;}
.sf-card-actions{display:flex;gap:14px;padding-top:8px;border-top:1px solid rgba(255,255,255,.06);}
.sf-action-btn{display:flex;align-items:center;gap:5px;background:transparent;border:none;color:#64748b;font-family:'DM Sans',sans-serif;font-size:13px;cursor:pointer;padding:4px 6px;border-radius:7px;transition:all .15s;}
.sf-action-btn:hover{color:#e2e8f0;background:rgba(255,255,255,.06);}
.sf-action-btn.liked{color:#f472b6;}
/* Comments */
.sf-comments{margin-top:10px;padding-top:10px;border-top:1px solid rgba(255,255,255,.06);}
.sf-comment{display:flex;gap:8px;margin-bottom:8px;}
.sf-comment-avatar{width:28px;height:28px;border-radius:50%;background:rgba(99,102,241,.15);display:flex;align-items:center;justify-content:center;font-size:11px;color:#818cf8;flex-shrink:0;}
.sf-comment-body{flex:1;background:rgba(255,255,255,.04);border-radius:10px;padding:7px 10px;}
.sf-comment-name{font-size:11px;font-weight:700;color:#94a3b8;margin-bottom:2px;}
.sf-comment-text{font-size:13px;color:#e2e8f0;}
.sf-comment-input{width:100%;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:10px;padding:8px 12px;color:#e2e8f0;font-family:'DM Sans',sans-serif;font-size:13px;outline:none;margin-top:6px;}
/* Empty */
.sf-empty{text-align:center;padding:50px 20px;color:#334155;}
.sf-empty-ico{font-size:44px;margin-bottom:12px;}
@keyframes spin{to{transform:rotate(360deg)}}
.sf-spinner{width:28px;height:28px;border:3px solid rgba(99,102,241,.15);border-top-color:#6366f1;border-radius:50%;animation:spin .7s linear infinite;margin:40px auto;}
`;

const TYPE_BADGE = {
  checkin: <span className="sf-post-type sf-type-checkin">📍 Check-in</span>,
  achievement: <span className="sf-post-type sf-type-achievement">🏅 Achievement</span>,
  post: null,
  review: <span className="sf-post-type sf-type-checkin">⭐ Review</span>,
};

function PostCard({ post, onLike, onComment, currentUserId }) {
  const [showComments, setShowComments] = useState(false);
  const [commentText, setCommentText] = useState('');
  const [comments, setComments] = useState(post.comments || []);
  const [likeCount, setLikeCount] = useState(post.likeCount || 0);
  const [liked, setLiked] = useState((post.likes||[]).includes(currentUserId));

  const handleLike = async () => {
    const { data } = await api.post(`/social/posts/${post._id}/like`);
    setLiked(data.liked);
    setLikeCount(data.likeCount);
  };

  const handleComment = async (e) => {
    if (e.key !== 'Enter' || !commentText.trim()) return;
    try {
      const { data } = await api.post(`/social/posts/${post._id}/comment`, { text: commentText });
      setComments(c => [...c, data]);
      setCommentText('');
    } catch {}
  };

  const u = post.userId;
  const avatarInitial = (u?.username || '?')[0].toUpperCase();

  return (
    <div className="sf-card">
      <div className="sf-card-head">
        <Link to={`/${u?.primaryFlapid || ''}`} className="sf-avatar">
          {u?.user_photo ? <img src={u.user_photo} alt=""/> : avatarInitial}
        </Link>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:'flex',alignItems:'center',gap:7,flexWrap:'wrap'}}>
            <Link to={`/${u?.primaryFlapid || ''}`} className="sf-user-name">{u?.username || 'User'}</Link>
            {TYPE_BADGE[post.type]}
          </div>
          <div className="sf-time">{new Date(post.createdAt).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'})}</div>
        </div>
      </div>

      {post.placeName && (
        <div className="sf-place-tag">📍 {post.placeName}</div>
      )}

      {post.text && <div className="sf-card-text">{post.text}</div>}

      {post.photos?.length > 0 && (
        <div className="sf-card-photos">
          {post.photos.map((p,i) => <img key={i} src={p} alt="" className="sf-card-photo"/>)}
        </div>
      )}

      {post.badgeId && (
        <div style={{background:'rgba(245,166,35,.08)',border:'1px solid rgba(245,166,35,.2)',borderRadius:10,padding:'8px 12px',marginBottom:10,fontSize:13,color:'#fbbf24'}}>
          🏅 Earned a new badge!
        </div>
      )}

      <div className="sf-card-actions">
        <button className={`sf-action-btn${liked?' liked':''}`} onClick={handleLike}>
          {liked ? '❤️' : '🤍'} {likeCount > 0 ? likeCount : ''}
        </button>
        <button className="sf-action-btn" onClick={()=>setShowComments(s=>!s)}>
          💬 {comments.length > 0 ? comments.length : ''}
        </button>
        <button className="sf-action-btn" onClick={()=>navigator.share?.({text:post.text,url:window.location.href})||navigator.clipboard.writeText(window.location.href)}>
          🔗 Share
        </button>
      </div>

      {showComments && (
        <div className="sf-comments">
          {comments.map((c,i) => (
            <div key={i} className="sf-comment">
              <div className="sf-comment-avatar">{(c.userName||'?')[0].toUpperCase()}</div>
              <div className="sf-comment-body">
                <div className="sf-comment-name">{c.userName}</div>
                <div className="sf-comment-text">{c.text}</div>
              </div>
            </div>
          ))}
          <input className="sf-comment-input" placeholder="Add a comment… (Enter to post)"
            value={commentText} onChange={e=>setCommentText(e.target.value)} onKeyDown={handleComment}/>
        </div>
      )}
    </div>
  );
}

export default function SocialFeed() {
  const navigate  = useNavigate();
  const [tab,     setTab]     = useState('feed');
  const [posts,   setPosts]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [text,    setText]    = useState('');
  const [posting, setPosting] = useState(false);
  const [me,      setMe]      = useState(null);

  const load = useCallback(async (t = tab) => {
    setLoading(true);
    try {
      const endpoint = t === 'feed' ? '/social/feed' : '/social/explore';
      const { data } = await api.get(endpoint);
      setPosts(data);
    } catch { setPosts([]); }
    setLoading(false);
  }, [tab]);

  useEffect(() => {
    api.get('/users/profile').then(r => setMe(r.data)).catch(() => navigate('/login'));
    load();
  }, [load, navigate]);

  const handleTabChange = (t) => { setTab(t); load(t); };

  const post = async () => {
    if (!text.trim()) return;
    setPosting(true);
    try {
      const { data } = await api.post('/social/posts', { text, type: 'post' });
      setPosts(p => [data, ...p]);
      setText('');
    } catch (e) { alert(e.response?.data?.error || 'Post failed'); }
    setPosting(false);
  };

  return (
    <div className="sf-root">
      <style>{CSS}</style>

      <div className="sf-header">
        <Link to="/dashboard" className="sf-logo">flap<span>.</span></Link>
        <div className="sf-tabs">
          {[['feed','👥 Following'],['discover','🌍 Discover']].map(([id,label])=>(
            <button key={id} className={`sf-tab${tab===id?' active':''}`} onClick={()=>handleTabChange(id)}>{label}</button>
          ))}
        </div>
      </div>

      <div className="sf-body">
        {/* Composer */}
        {tab === 'feed' && (
          <div className="sf-compose">
            <div className="sf-compose-row">
              <div className="sf-compose-avatar">
                {me?.user_photo ? <img src={me.user_photo} alt=""/> : (me?.username||'?')[0]?.toUpperCase()}
              </div>
              <textarea className="sf-compose-input" placeholder="Share what's on your mind, or where you are…"
                value={text} onChange={e=>setText(e.target.value)}/>
            </div>
            <div className="sf-compose-footer">
              <button className="sf-post-btn" disabled={!text.trim()||posting} onClick={post}>
                {posting ? '⏳' : 'Post'}
              </button>
            </div>
          </div>
        )}

        {loading ? <div className="sf-spinner"/> :
         posts.length === 0 ? (
          <div className="sf-empty">
            <div className="sf-empty-ico">{tab==='feed'?'👥':'🌍'}</div>
            <div style={{fontSize:15,fontWeight:700,color:'#e2e8f0',marginBottom:6}}>
              {tab==='feed' ? 'Your feed is empty' : 'No posts yet'}
            </div>
            <div style={{fontSize:13}}>
              {tab==='feed' ? 'Follow people to see their posts here.' : 'Be the first to post!'}
            </div>
            {tab==='feed' && <button onClick={()=>handleTabChange('discover')} className="sf-post-btn" style={{marginTop:16}}>Discover People</button>}
          </div>
        ) : posts.map(p => (
          <PostCard key={p._id} post={p} currentUserId={me?._id} onLike={()=>{}} onComment={()=>{}}/>
        ))}
      </div>
    </div>
  );
}